import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from "axios";
import DOMPurify from "dompurify";
import HTMLParse from "html-react-parser";

//STYLES
import * as SectionsStyles from "../../mainStyle/components/homeSections/styles/sections";

function EditorialView(props) {
    const params = useParams();
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const navBarSettings = useSelector((state) => state.navBar);
    const [editorial, setEditorial] = useState([]);
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (props.scroll) {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
        handleLoad(params.editorialUUID);
    });

    function handleLoad(id) {
        const data = { editorialUUID: id };
        Axios.post("/pods/userRouter/getEditorial", data)
            .then((res) => {
                const data = res.data;
                let content = data.editorial.content;

                for (const image of data.images) {
                    content = content.replace(
                        `{${image.id}}`,
                        `<img src="/content/${image.url}" width=${image.width} height=${image.height} style='float:${image.positioning}; margin-right:20px; margin-bottom:10px;'/>`
                    );
                }
                setEditorial({ ...data.editorial, content: content });
                setImages(data.images);
            })
            .catch((err) => console.log(err));
    }
    return (
        <div
            style={{
                ...SectionsStyles.backgroundPicture,
                backgroundImage: `url('/content/mainStyle/sectionsBackgrounds/${navBarSettings.backgroundImages[`${params.pageNav}Image`]}')`
            }}
        >
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        <div style={{ ...SectionsStyles.contentContianer, ...SectionsStyles.editorialContent }}>
                            {HTMLParse(DOMPurify.sanitize(editorial.content))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditorialView;
